module.exports = __webpack_public_path__ + "static/media/111.45763289.png";